export const ApiPaths = {
    GET_CONFIGURATION: "/api/configuration",
    PRACTICE: "/api/practice/",
    SCENARIO: "/api/scenario/",
    USER_SCENARIO: "/api/scenario/user/",
    SUBMIT: "/api/scenario/user/",
    PUBLISH_SCENARIO: "/api/scenario/publish/"
};
